/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ArticleAdminModel } from './ArticleAdminModel';
import {
    ArticleAdminModelFromJSON,
    ArticleAdminModelFromJSONTyped,
    ArticleAdminModelToJSON,
} from './ArticleAdminModel';

/**
 *
 * @export
 * @interface ListArticleAdminResponse
 */
export interface ListArticleAdminResponse {
    /**
     *
     * @type {number}
     * @memberof ListArticleAdminResponse
     */
    limit: number;
    /**
     *
     * @type {number}
     * @memberof ListArticleAdminResponse
     */
    offset: number;
    /**
     *
     * @type {number}
     * @memberof ListArticleAdminResponse
     */
    total: number;
    /**
     *
     * @type {Array<ArticleAdminModel>}
     * @memberof ListArticleAdminResponse
     */
    articles: Array<ArticleAdminModel>;
}

/**
 * Check if a given object implements the ListArticleAdminResponse interface.
 */
export function instanceOfListArticleAdminResponse(value: object): boolean {
    if (!('limit' in value)) return false;
    if (!('offset' in value)) return false;
    if (!('total' in value)) return false;
    if (!('articles' in value)) return false;
    return true;
}

export function ListArticleAdminResponseFromJSON(json: any): ListArticleAdminResponse {
    return ListArticleAdminResponseFromJSONTyped(json, false);
}

export function ListArticleAdminResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ListArticleAdminResponse {
    if (json == null) {
        return json;
    }
    return {
        limit: json['limit'],
        offset: json['offset'],
        total: json['total'],
        articles: (json['articles'] as Array<any>).map(ArticleAdminModelFromJSON),
    };
}

export function ListArticleAdminResponseToJSON(value?: ListArticleAdminResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        limit: value['limit'],
        offset: value['offset'],
        total: value['total'],
        articles: (value['articles'] as Array<any>).map(ArticleAdminModelToJSON),
    };
}
